export const CONTINUE_PURCHASE_LINK = "continuePurchaseLink"
export const MODEL_NAME = "modelName"
export const SIDEBAR_WIDTH = 450
export const SIDEBAR_WIDTH_SUMMARY = 830
export const SIDEBAR_PADDING = 20
export const STEPS_NAV_DESKTOP_HEIGHT = 50
export const STEPS_TEXT = ["רמת גימור", "צבע", "ריפוד", "אביזרים", "סיכום"]
export const STEPS_EN = {
  detailing: "/detailing",
  color: "/color",
  upholstery: "/upholstery",
  accessories: "/accessories",
  summary: "/summary",
  order: "/order",
  payment: "/payment",
}

export enum Font {
  OENaPro = "OENaPro",
  MazdaType = "MazdaType, OENaPro, sans serif",
  Heebo = "Heebo, MazdaType, sans serif",
}
